<template>
  <div class="header">
    <div class="logo-wrapper">
      <!--logo-->
      <router-link :to="{path:'/'}"
        ><img src="@/assets/images/logo.png"
      /></router-link>
      <!--nav-->
      <div class="nav">
        <ul>
          <li>
            <router-link :to="{path:'/'}">
              <div><img src="@/assets/images/news-icon.png" /></div>
              <p>信息数据库</p>
            </router-link>
          </li>
          <li>
            <a href="http://www.pestchina.com/pest/SitePages/PestInfoSearch.aspx">
              <div><img src="@/assets/images/online-search.png" /></div>
              <p>在线查询</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="mune-wrapper">
      <div class="mune-btm">
        <span>{{time1}} </span>丨
        <span v-if="time2=='am'"> 上午好！</span>
        <span v-if="time2=='pm'"> 下午好！</span>
      </div>
    </div>
  </div>
</template>

<script>
  import './header.scss'
  import dayjs from "dayjs";
  import 'dayjs/locale/zh-cn' // 按需加载

  export default {
    name: 'Header',
    data(){
      return {
        time1:"",
        time2:""
      }
    },
    created () {
      
      dayjs.locale('zh-cn')
      const t = dayjs();
      this.time1 = t.locale('zh-cn').format('YYYY年MM月DD日 dddd')
      this.time2 = t.locale('zh-cn').format( 'a')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/base/header/header.vue